import * as countryCodes from 'country-codes-list';

type CountryData = {
  countryNameEn: string;
  countryNameLocal: string;
  countryCode: string;
  currencyCode: string;
  currencyNameEn: string;
  tinType: string;
  tinName: string;
  officialLanguageCode: string;
  officialLanguageNameEn: string;
  officialLanguageNameLocal: string;
  countryCallingCode: string;
  areaCodes?: any[];
  region: string;
  flag: string;
};

const countryDialCodeMap = new Map<string, string>();

export const getDialCodeByCountry = (countryCode: string): string | null => {
  if (countryDialCodeMap.has(countryCode)) {
    const cached = countryDialCodeMap.get(countryCode)!;
    return cached || null;
  }
  const all = countryCodes.all() as CountryData[];
  const country = all.find((c: CountryData) => c.countryCode.toUpperCase() === countryCode.toUpperCase());
  const dialCode = country?.countryCallingCode ? `+${country.countryCallingCode}` : null;
  countryDialCodeMap.set(countryCode, dialCode ?? '');
  return dialCode;
};

type FormatE164PhoneNumberParams = {
  phoneNumber: string;
  countryCode: string;
};

export const formatE164PhoneNumber = ({ phoneNumber, countryCode }: FormatE164PhoneNumberParams): string => {
  if (process.env.NODE_ENV === 'development') {
    return `+82${phoneNumber}`;
  }
  const dialCode = getDialCodeByCountry(countryCode) ?? '';
  return `${dialCode}${phoneNumber}`;
};
